<cw-ci-data-table #scanConfigurationsDataTable
  tileTitle="Scan Configurations"
  addToolTip="Create a new scan configuration"
  refreshToolTip="Reload scan configuration list"
  defaultSortField="name"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadScanConfigurations($event)"
  (addHandler)="addScanConfiguration($event)"
  (selectHandler)="editScanConfiguration($event)"
  [items]="scanConfigurationList">

  <cw-ci-table-column columnName="name" columnTitle="Name" sortField="name" searchField="name" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="definitionId" columnTitle="Definition Id" sortField="definitionId" searchField="definitionId" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="type" columnTitle="Type" filterType="select" [filterOptions]="['OVAL', 'XCCDF']"></cw-ci-table-column>
  <cw-ci-table-column columnName="s3Key" columnTitle="S3 Key" sortField="s3Key" searchField="s3Key" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="active" columnTitle="Active" [output]="activeTemplate" sortField="active" searchField="active" filterType="select" [filterOptions]="[{display:'Active', value:'true'}, {display:'Inactive', value:'false'}]"></cw-ci-table-column>
  <ng-template let-element #activeTemplate><mat-icon color="accent" *ngIf="element.active">check</mat-icon></ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the scan configuration" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editScanConfiguration($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>